export default __webpack_public_path__ + "static/media/logoBPayVerticalBlue64.bfe26302.svg";